import React from 'react'
import { Row, Col, Divider, Tag } from 'antd'
import { H4, P, Span, B } from '../override/Typography'
import { DATE_TIME_FORMAT } from '../../share/Constants'
import moment from 'moment'
import { formatBytes } from '../../share/helpers'
//import { StringResources } from '../../share/StringResources'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useContext } from 'react'
import VaultContext from '../../contexts/VaultContext'
import { AES, enc } from 'crypto-js'

function Field({ title, value }) {
  return (
    <Row style={{ fontSize: 12, padding: '3px 0' }} gutter={8}>
      <Col span={8}>
        <Span>{title}</Span>
      </Col>
      <Col span={16} style={{ textAlign: 'left' }}>
        <B>{value}</B>
      </Col>
    </Row>
  )
}

export default function FileInformation({ record, extra }) {
  const { t } = useTranslation()
  const { privateFolderKey } = useContext(VaultContext)
  const { activeDocuments } = useSelector(state => state.documents)
  const privateFolder = activeDocuments.find(record => record.isPrivate)
  const privateFile =
    !!privateFolder &&
    record.path?.slice(0, privateFolder?.path.length) === privateFolder?.path
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 10
        }}
      >
        <H4>{t('FILE_INFORMATION')}</H4>
        {extra}
      </div>
      <P>
        {privateFile
          ? AES.decrypt(record.description, privateFolderKey).toString(
              enc.Latin1
            )
          : record.description}
      </P>
      <Divider />
      <Field title={t('SIZE')} value={formatBytes(record.size)} />
      <Field
        title={t('CREATED')}
        value={moment(record.uploadTime).format(DATE_TIME_FORMAT)}
      />
      <Field
        title={t('TAGS')}
        value={record.tags?.map(tag => (
          <Tag key={tag}>
            {privateFile
              ? AES.decrypt(tag, privateFolderKey).toString(enc.Latin1)
              : tag}
          </Tag>
        ))}
      />
      <Field title={t('ORIGINAL_PATH')} value={record.path} />
    </>
  )
}
